import { render } from "./ActualizaDatos.vue?vue&type=template&id=1a900582&scoped=true"
import script from "./ActualizaDatos.vue?vue&type=script&lang=js"
export * from "./ActualizaDatos.vue?vue&type=script&lang=js"

import "./ActualizaDatos.vue?vue&type=style&index=0&id=1a900582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a900582"]])

export default __exports__